import { createTheme } from "@mui/material/styles";
import overrides from "./overrides";
import palette from "./palette";
import typography from "./typography";

const theme = createTheme({
  overrides,
  palette,
  typography,
  components: {
    MuiTextField: {
      defaultProps: {
        autoComplete: "off",
        size: "small",
      },
    },
  },
});

export default theme;
